// src/services/t321PermissionLinks.js
// T321 permission name -> permissions.amazon.com team page (the same link type T178 records carry
// in permissionLinks). T321 records store only selectedPermissionNames, so the approver portal
// resolves the links here. Names are the requester portal's T321 catalogue
// (approval-portal-react prod-release/frontend-src/data/t321PermissionCatalog.js, which matches
// "321 Permissions Repository Base Permissions UPDATED 10-14.csv"); tests/t321PermissionLinks.test.mjs
// checks every link equals the catalogue's. A name not listed here has no known link and renders as
// plain text (link ''). Used only in tenant === 'T321' branches.

const TEAM_PAGE = 'https://permissions.amazon.com/a/team/';

const T321_PERMISSION_NAMES = {
    base: [
        'Tenant 321 - SIV Signed access',
        'CalypsoInvestigators-SOA-SIV-NA-Team',
        'Tenant 321 Base Access - Bindle',
        'CalypsoInvestigators-VerifiedId-Approval-NA',
        'CalypsoInvestigators-VerifiedId-Approval-NA-CN',
    ],
    arvt: [
        'ARVT - Allow IPV page',
        'ARVT - Audit access',
    ],
    tools: [
        'calypso-ape-users team', 'Calypso-SOA-SIV-NA-ReadOnlyTask', 'CalypsoAPETier3AccessEU',
        'CalypsoBulkActionsProd', 'CalypsoCAKYCSignedlinkaccess', 'CalypsoCustomerIdBR-Signedinlink',
        'CalypsoCustomerIdGC-Signedinlink', 'CalypsoCustomerIdKYC-EU-Signedinlink', 'CalypsoCustomerIdNA-Signedinlink',
        'CalypsoEmailUtilityEUProdSearchSignOnly', 'CalypsoEUCustomerIdSearchSignOnly', 'CalypsoNACustomerIdSearchSignOnly',
        'CalypsoTaskIdKYC-EU-FE-Remus-EU-Signedinlink', 'CalypsoUnfetteredSearchCA', 'APUK-SAM-Queries-Wiki',
        'Alexandria_document_view_CDT_EU', 'Alexandria_document_view_CDT_NA', 'ape-compliance-policy_ldap',
        'APUK Investigator Dashboard Access', 'APUK-Compliance-Restricted-Policy', 'apuk-screening-tier4-queues',
        'eu-cams-kyc-documents', 'RCS PML Reviewers', 'RCS-APUK-SAM-INV', 'remus-sanctions-investigation-jp',
        'remus-sanctions-investigation-na', 'sanctions-escalation-jp - Sanctions Task ID', 'Sanctions-NA-Tier2',
        'TRMS-KYC-USERS - LDAP - Access to KYC Community Help Page - Country Guides and others',
        'TRMS-KYC-USERS_ANT to be Deprecated',
    ],
    tools_pml: [
        'calypso-ape-user', 'calypso-apuk-user', 'calypso-risk-level-override', 'calypso-risk-level-override-aws-mp',
        'Calypso-SW-KYC-NA-ViewAccess-Full', 'Calypso-SW-KYC-NA-ViewAccess-Task', 'Calypso-SW-KYC-NA-WorkAccess-Tier1',
        'Calypso-SW-KYC-NA-WorkAccess-Tier2', 'Calypso-SW-KYC-NA-WorkAccess-Tier3', 'CalypsoAPETier1AccessEU',
        'CalypsoAPETier2AccessEU', 'CalypsoBRTier1Access', 'CalypsoBRTier2Access', 'CalypsoBRTier3Access',
        'CalypsoBRViewAccessTask', 'CalypsoCATier1Access', 'CalypsoCATier2Access', 'CalypsoCATier3Access',
        'CalypsoCAViewAccessTask', 'CalypsoGCTier1Access', 'CalypsoGCTier3Access', 'CalypsoInvestigators-AWS-MP-EU-Tier1',
        'CalypsoInvestigators-AWS-MP-EU-Tier2', 'CalypsoInvestigators-AWS-MP-EU-Tier3', 'CalypsoManagers-AWS-MP-EU',
        'compliance-attributes-prod', 'RampConsole-EU-Compliance', 'rampconsole-eu-dloa', 'rampconsole-eu-doc-dpl',
        'rampconsole-eu-doc-sanctions', 'rampconsole-eu-full-access', 'rampconsole-eu-sanctionsinvestigators',
        'rca-sop-users', 'trms-rca-users', 'acsuk-compliance-reporting-uk-SharedMB', 'ape-sam-test',
    ],
};

const LINKS = new Map(
    Object.values(T321_PERMISSION_NAMES).flat().map(n => [n, TEAM_PAGE + encodeURIComponent(n)])
);

// Link for one T321 permission name, or '' when it has no known link.
const t321PermissionLink = (name) => LINKS.get(String(name == null ? '' : name).trim()) || '';

// selectedPermissionNames -> [{ name, link }] (same shape as T178 permissionLinks; link '' = plain text).
const t321PermissionLinks = (names) =>
    (Array.isArray(names) ? names : []).map(n => ({ name: n, link: t321PermissionLink(n) }));

export { T321_PERMISSION_NAMES, t321PermissionLink, t321PermissionLinks };
